<template>
  <div class="car_rent_order">
    <div class="car_rent_order_nav">
      <navbar
        title="详情"
        :lefticon="lefticon"
        :lefticonheight="2.4"
        :lefticonwidth="2.4"
        :fontweight="700"
        :fontsize="'1.7rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="all" :class="{ shouldPay: detailInfo.status == 10 }">
      <div class="box">
        <van-row class="goods">
          <van-col span="24" class="status"
            >{{ statusLabel[detailInfo.status]
            }}<span class="down_count" v-if="detailInfo.status == 10"
              >剩余时间 {{ downCount }}</span
            >
            <span
              class="refunded_tips"
              v-if="detailInfo.status == -30 && detailInfo.refund"
              >已退至您的{{
                returnType[detailInfo.refund.actual_return_type]
              }}</span
            >
            <span class="refunded_tips" v-if="detailInfo.status == -20"
              >请耐心等待</span
            >
            <span
              class="operation"
              @click="cancelPay()"
              v-if="detailInfo.status == 10"
              >取消支付</span
            ></van-col
          >
          <van-col
            span="24"
            class="tips tips_top"
            v-if="detailInfo.status == -20 && detailInfo.reject_reason"
            ><p class="tip_con">
              <img src="../../assets/carRent/tips@2x.png" />{{
                detailInfo.reject_reason
              }}
            </p></van-col
          >
          <van-col span="24" class="goods_info">
            <img
              v-if="
                detailInfo.car_order_goods && detailInfo.car_order_goods.images
              "
              :src="detailInfo.car_order_goods.images[0]"
            />
            <div class="goods_r" v-if="detailInfo.car_order_goods">
              <p class="name">{{ detailInfo.car_order_goods.goods_name }}</p>
              <p class="stock">
                <span
                  >所选颜色：{{
                    detailInfo.car_order_goods.specification_name
                  }}</span
                >
              </p>
              <p class="money">
                指导价￥{{ detailInfo.car_order_goods.guide_price }}
              </p>
              <p class="unit_price">
                <span class="label_">￥</span>{{ detailInfo.daily_rent }}
                <span class="dec">/日租价</span>
              </p>
            </div>
          </van-col>
        </van-row>

        <van-row class="order_info">
          <van-col span="24" class="info_title">车辆信息</van-col>
          <van-col
            span="24"
            class="car_info"
            v-if="detailInfo.car_order_goods"
            >{{ detailInfo.car_order_goods.description }}</van-col
          >
        </van-row>

        <van-row class="order_info">
          <van-col span="24" class="info_title">用户信息</van-col>
          <van-col span="24" class="member_info info1">
            <span class="info_tit">姓名：</span>{{ detailInfo.lessees_name }}
          </van-col>
          <van-col span="24" class="member_info">
            <span class="info_tit">电话：</span>{{ detailInfo.lessees_mobile }}
          </van-col>
          <van-col span="24" class="member_info">
            <span class="info_tit">身份证：</span>{{ detailInfo.id_card }}
          </van-col>
          <van-col span="24" class="member_info">
            <span class="info_tit">地区：</span>{{ detailInfo.area_name }}
          </van-col>
          <van-col span="24" class="member_info">
            <span class="info_tit">详细地址：</span>{{ detailInfo.address }}
          </van-col>
          <van-col span="24" class="member_info"> 身份正正反面 </van-col>
          <van-col
            span="24"
            class="member_info info_img"
            v-if="detailInfo.id_card_images"
          >
            <img @click="imgPreview(0)" :src="detailInfo.id_card_images[0]" />
            <img
              class="img_r"
              @click="imgPreview(1)"
              :src="detailInfo.id_card_images[1]"
            />
          </van-col>
          <van-col span="24" class="member_info"> 驾驶证 </van-col>
          <van-col span="24" class="member_info info_img">
            <img
              @click="imgPreview(2)"
              :src="detailInfo.drivers_license_image"
            />
          </van-col>
        </van-row>

        <van-row class="order_info">
          <van-col span="24" class="info_title">订单信息</van-col>
          <van-col span="24" class="member_info info1">
            订单金额：￥{{ detailInfo.deposit_amount }}
          </van-col>
          <van-col span="24" class="member_info">
            订单编号：<span ref="copytxt">{{ detailInfo.order_num }}</span>
            <img
              class="copy"
              src="../../assets/carRent/copy@2x.png"
              @click="copyCode"
            />
          </van-col>
          <template
            v-if="
              detailInfo.status != 10 &&
              detailInfo.status != -10 &&
              detailInfo.deposit_pay_info
            "
          >
            <van-col
              span="24"
              class="member_info info1"
              v-if="detailInfo.deposit_pay_info.deduct_balance != 0"
            >
              个人余额抵扣：￥{{ detailInfo.deposit_pay_info.deduct_balance }}
            </van-col>
            <van-col
              span="24"
              class="member_info info1"
              v-if="detailInfo.deposit_pay_info.deduct_coin != 0"
            >
              红包抵扣：￥{{ detailInfo.deposit_pay_info.deduct_coin }}
            </van-col>
            <van-col
              span="24"
              class="member_info info1"
              v-if="
                detailInfo.deposit_pay_info.deduct_balance != 0 ||
                detailInfo.deposit_pay_info.deduct_coin != 0
              "
            >
              实付款：￥{{ detailInfo.deposit_pay_info.pay_amount }}
            </van-col>
          </template>
          <van-col span="24" class="member_info">
            申请时间：{{ detailInfo.created_at }}
          </van-col>
          <van-col
            span="24"
            class="member_info"
            v-if="detailInfo.status == -30 && detailInfo.refund"
          >
            退款时间：{{ detailInfo.refund.payment_date }}
          </van-col>
        </van-row>
      </div>
    </div>
    <btn
      v-if="detailInfo.status == 10"
      class="pay_btn"
      :btntext="'去支付'"
      :btnwidth="'34.3rem'"
      :height="'4.8rem'"
      :bgcolor="'linear-gradient(to right, #49A6FF, #236DFE)'"
      :borderradius="'0.6rem'"
      :btncolor="'#fff'"
      :fontsize="'1.6rem'"
      :fontweight="700"
      @btnClick="goPay"
    />
    <van-popup class="tipPopup" v-model="tipsShow">
      <p class="title">温馨提示</p>
      <p class="con">
        您的申请已提交成功，申请正在审核中，稍后将有业务人员与您联系
      </p>
      <btn
        :btntext="'返回首页'"
        :btnwidth="'11.4rem'"
        :height="'3.6rem'"
        :bgcolor="'linear-gradient(to right, #49A6FF, #236DFE)'"
        :borderradius="'0.6rem'"
        :btncolor="'#fff'"
        :fontsize="'1.4rem'"
        :btnmargin="'0 0 0 6.9rem'"
        @btnClick="goHome"
      />
    </van-popup>
  </div>
</template>
<script>
import navbar from "../purchaseSupplier/components/nav-bar.vue";
import btn from "../purchaseSupplier/components/button.vue";
import { ImagePreview } from "vant";
import dsbridge from "dsbridge";

export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/carRent/reback@2x.png"),
      detailInfo: {},
      downCount: "00:00",
      statusLabel: {
        10: "待支付",
        20: "审核中",
        30: "审核通过",
        "-10": "已取消",
        "-20": "退款中",
        "-30": "订金已退",
      },
      facility: "",
      tipsShow: false,
      thisPageImgs: [],
      returnType: {
        1: "银联账户",
        2: "支付宝账户",
        3: "微信账户",
        4: "个人余额",
        5: "小巴余额",
      },
    };
  },
  created() {
    this.getInfo();
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
    window.setPay = this.setPay;
    this.deductionUA();
  },
  methods: {
    goBack() {
      if (this.$route.query.from) {
        this.$router.go(-1);
      } else {
        this.$router.replace("/carRent/carList");
      }
    },
    goHome() {
      this.$router.go(-2);
    },
    getInfo() {
      this.$api
        .post("/onorder/member/car_rental/order/detail", {
          order_num: this.$route.query.order_num,
        })
        .then((res) => {
          this.detailInfo = res;
          res.created_at = res.created_at.replace(/-/g, "/");
          let end_time =
            Math.floor(new Date(res.created_at).getTime() / 1000) + 30 * 60;
          this.setTimer(end_time);
          this.thisPageImgs = res.id_card_images;
          this.thisPageImgs.push(res.drivers_license_image);
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    cancelPay() {
      this.$api
        .post("/order/member/order/cancel", {
          ordersn: this.detailInfo.deposit_pay_info.ordersn,
        })
        .then((res) => {
          this.detailInfo.status = -10;
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    goPay() {
      let param = {
        actual_amount: this.detailInfo.deposit_amount,
        order_amount: this.detailInfo.deposit_amount,
        ordersn: this.detailInfo.deposit_pay_info.ordersn,
        order_type: "car_rental_deposit",
      };
      if (this.facility == "ios") {
        let that = this;
        dsbridge.call("goPay", JSON.stringify(param), function (v) {
          that.setPay(v);
        });
      } else if (this.facility == "android") {
        this.params(JSON.stringify(param), JSON.stringify(param), "goPay");
      }
    },
    setPay(v) {
      let data = JSON.parse(v);
      if (data.code == 0) {
        this.tipsShow = true;
      } else {
        this.$toast("支付失败");
      }
    },
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
        this.facility = "ios";
      } else if (/android/.test(ua)) {
        this.facility = "android";
      }
    },
    copyCode() {
      const rechage_range = document.createRange();
      rechage_range.selectNode(this.$refs.copytxt);
      const rechage_selection = window.getSelection();
      if (rechage_selection.rangeCount > 0) rechage_selection.removeAllRanges();
      rechage_selection.addRange(rechage_range);
      document.execCommand("Copy");
      this.$toast("复制成功");
      rechage_selection.removeAllRanges();
    },
    setTimer(end_time) {
      var _that = this;
      var current = Math.floor(new Date().getTime() / 1000);
      var ts = end_time - current;
      if (ts <= 0) {
        _that.downCount = "00:00";
        clearInterval(timer);
        return false;
      } else {
        _that.getTimeCount(ts, _that);
      }
      var timer = setInterval(function () {
        var current = Math.floor(new Date().getTime() / 1000);
        var ts = end_time - current;
        if (ts <= 0) {
          _that.downCount = "00:00";
          clearInterval(timer);
          _that.getInfo();
        } else {
          _that.getTimeCount(ts, _that);
        }
      }, 1000);
    },
    //支付时间倒计时
    getTimeCount(ts, _that) {
      var mm = parseInt((ts / 60) % 60, 10);
      var ss = parseInt(ts % 60, 10);
      this.downCount = _that.checkTime(mm) + ":" + _that.checkTime(ss);
    },
    imgPreview(index) {
      ImagePreview({
        images: this.thisPageImgs,
        startPosition: index,
      });
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.car_rent_order {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .car_rent_order_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .pay_btn {
    position: fixed;
    bottom: 1.4rem;
    left: 1.6rem;
  }

  .all {
    padding: 10rem 0 1.2rem;
    box-sizing: border-box;
    height: 100%;

    .box {
      padding: 0 1.2rem;
      height: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;

      .goods {
        min-height: 16.9rem;
        border-radius: 0.8rem;
        background: #fff;
        margin-bottom: 1.2rem;
        padding: 0.6rem 0 0;

        .status {
          height: 4rem;
          line-height: 4rem;
          color: #333;
          font-size: 1.4rem;
          font-weight: 700;
          padding: 0 1.6rem;

          .down_count {
            color: #ff4747;
            margin-left: 1rem;
          }

          .refunded_tips {
            color: #999;
            font-size: 1.2rem;
            margin-left: 1rem;
          }

          .operation {
            color: #236dfe;
            font-size: 1.2rem;
            float: right;
          }
        }

        .tips {
          padding: 0 1.4rem;
          box-sizing: border-box;

          .tip_con {
            color: #ff4747;
            font-size: 1.2rem;
            min-height: 2.8rem;
            line-height: 2rem;
            border-radius: 0.4rem;
            background: #fff2f2;
            padding: 0.4rem 1.2rem;

            img {
              width: 1.2rem;
              margin-right: 0.6rem;
              vertical-align: middle;
            }
          }
        }

        .tips_top {
          margin-bottom: 1.2rem;
        }

        .tips_bottom {
          margin-top: 1rem;
        }

        .goods_info {
          padding: 0 1.4rem 1rem;
          box-sizing: border-box;
          position: relative;

          img {
            position: absolute;
            top: 0;
            left: 1.4rem;
            width: 10.7rem;
            height: 8.1rem;
            border-radius: 0.6rem;
          }

          .goods_r {
            padding-left: 11.7rem;

            .name {
              font-size: 1.6rem;
              color: #000;
              font-weight: 700;
              height: 4.4rem;
              line-height: 2.2rem;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              white-space: normal;
            }

            .stock {
              height: 1.8rem;
              margin: 0.4rem 0;

              span {
                color: #333;
                height: 1.6rem;
                line-height: 1.6rem;
                font-size: 1rem;
                font-weight: 700;
                border: solid 1px #c8c8c8;
                border-top-left-radius: 0.4rem;
                border-bottom-right-radius: 0.4rem;
                padding: 0 0.5rem;
              }
            }

            .money {
              color: #999;
              font-size: 1.2rem;
              margin-bottom: 0.4rem;
              line-height: 1.7rem;
              font-weight: 700;
            }

            .unit_price {
              color: #ff4747;
              font-size: 1.6rem;
              font-weight: 700;
              line-height: 2.2rem;

              .label_ {
                font-size: 1rem;
              }

              .dec {
                color: #999;
                font-size: 1rem;
              }
            }
          }
        }
      }

      .order_info {
        padding: 1.6rem;
        background: #fff;
        border-radius: 1rem;
        margin-top: 1.2rem;

        .info_title {
          color: #000;
          font-size: 1.6rem;
          font-weight: 700;
          height: 2.2rem;
          line-height: 2.2rem;
        }

        .car_info {
          background: #f7f9fb;
          border: solid 1px #efefef;
          border-radius: 0.4rem;
          padding: 1.6rem;
          counter-reset: #333;
          font-size: 1.4rem;
          line-height: 2rem;
          margin-top: 0.8rem;
        }

        .member_info {
          margin-top: 1.2rem;
          min-height: 2rem;
          line-height: 2rem;
          color: #333;
          font-size: 1.4rem;

          .info_tit {
            width: 7.8rem;
            display: inline-block;
          }

          .copy {
            width: 2rem;
            margin-left: 1rem;
            vertical-align: middle;
          }
        }

        .info1 {
          margin-top: 1.6rem;
        }

        .info_img {
          height: 9.1rem;

          img {
            width: 15.1rem;
            height: 9.1rem;
            float: left;
          }

          .img_r {
            float: right;
          }
        }
      }
    }
  }

  .shouldPay {
    padding-bottom: 7.8rem;
  }

  .tipPopup {
    width: 29.6rem;
    border-radius: 0.8rem;
    padding: 3rem 2.2rem 2.2rem;
    box-sizing: border-box;
    color: #333;

    .title {
      font-size: 1.6rem;
      font-weight: 700;
      text-align: center;
      margin-bottom: 2rem;
    }

    .con {
      font-size: 1.4rem;
      line-height: 2.5rem;
      margin-bottom: 4.2rem;
    }
  }
}
</style>




